import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import AuditLogComponent from '../../../components/common/AuditLogComponent';
import { csAdminApi } from '../../../services/api';
const AuditLogTab = ({ directorId, auditLogs: initialLogs = [] }) => {
  const [logs, setLogs] = useState(initialLogs);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLogs(initialLogs);
  }, [initialLogs]);

  useEffect(() => {
    if (!directorId) return undefined;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await csAdminApi.getDirectorAuditLog(directorId, { limit: 100 });
        if (!cancelled) {
          setLogs(res.data?.data || []);
        }
      } catch (_) {
        if (!cancelled) setLogs([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [directorId]);

  if (loading && !logs.length) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  return <AuditLogComponent auditLogs={logs} title="Director Audit Log" />;
};

export default AuditLogTab;
